import { RefObject, useEffect } from "react";

/** ⌘K / Ctrl+K focuses the hero search. Page-local for now — to widen
 *  app-wide later, mount in MainLayout with a navigate+focus handoff. */
export const useCommandK = (
  inputRef: RefObject<HTMLInputElement | null>,
): void => {
  useEffect(() => {
    const handler = (e: KeyboardEvent): void => {
      if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === "k") {
        e.preventDefault();
        inputRef.current?.focus();
      }
    };
    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, [inputRef]);
};
